import { SxProps, Theme } from '@mui/material'

export const containerSx: SxProps<Theme> = {
  background: 'linear-gradient(180deg, #184A9B 0%, #03378B 100%)',
  padding: { xs: '2.4rem', md: '8rem 5.6rem', lg: '8rem 4.8rem' },
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}

export const contentSx: SxProps<Theme> = {
  maxWidth: { lg: '117.6rem', xl: 'max-content' },
  width: { xl: '137rem' },
  gap: { xs: '1.6rem', md: '3.6rem' },
}

export const titleSx: SxProps<Theme> = {
  textAlign: 'center',
  color: (theme) => theme.palette.primary.contrastText,
}

export const numberSx: SxProps<Theme> = {
  minWidth: { xs: '3.6rem', md: '4.4rem' },
  minHeight: { xs: '3.6rem', md: '4.4rem' },
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: (theme) => theme.palette.background.paper,
}

export const textSx: SxProps<Theme> = {
  color: (theme) => theme.palette.primary.contrastText,
}

export const rowSx: SxProps<Theme> = {
  gap: { xs: '0.8rem', md: '2.4rem' },
  alignItems: { xs: 'flex-start', xl: 'center' },
}
